export const SET_PROFILE_INFO = 'SET_PROFILE_INFO';
